<template>
  <div class="ucenter">
    <communityHeader :router_url='router_url'></communityHeader>

    <div class="hd">
      <!-- 用户信息 -->
      <div class="user _width">

        <div class="user_center _height">

          <div class="error_img">
            <div class="error_img_conter fade_image_out">
              <img :src="error_login"
                   class="fade_image_out"
                   alt="">
            </div>
          </div>

          <img v-if="user_data_bag"
               :src="user_data_bag"
               alt=""
               class="user_bag">

          <!-- <img :src="user_data_bag!==''&& user_data_bag !== null ? user_data_bag :'@/assets/image/common/ta.png' "
               alt=""
               class="user_bag"> -->

          <!-- <img v-else
               src=""
               alt=""
               class="user_bag"> -->

          <!-- banner的用户信息 -->
          <div class="user_header_menu _width">

            <a href="javascript:;"
               class="header_img">
              <img :src="user_data.headimg"
                   :alt="user_data.realname">
            </a>

            <p class="user_name _width">{{user_data.realname}}</p>

            <p class="user_desc wrap">{{user_data.comment}}</p>
            <div class="follow_center _width">

              <button class="follow"
                      v-ripple="'rgba(255, 255, 255, 0.25)'"
                      @click="myclick(user_data.userId)">+ 我要开影展</button>

              <!-- <button class="follow"
                      v-else
                      v-ripple="'rgba(255, 255, 255, 0.25)'"
                      @click="go_commp()">+
                我要开影展</button> -->
            </div>

          </div>

          <!-- 上传封面图   @click="update_img()"-->
          <div class="_width up_bag">
            <div class="wrap">

              <button class="follow"
                      v-ripple="'rgba(255, 255, 255, 0.25)'">
                <el-upload class="avatar-uploader _width"
                           action="https://v.jingjiribao.cn/community/upload2"
                           :show-file-list="false"
                           name="imageName"
                           :on-success="handleAvatarSuccess"
                           :before-upload="beforeAvatarUpload">
                  上传封面图
                </el-upload>

              </button>

            </div>

          </div>

        </div>
        <!-- banner的用户信息 -->

      </div>
      <!-- 用户信息 end-->

      <!-- 导航 -->
      <div class="menu _width">
        <ul class="wrap padding _height">
          <li class="_width _heigth"
              @click="change(0)">作品<span v-if="user_data.topicCount">({{user_data.topicCount}})</span>
            <div :class="menubox== 0 ? 'show_top':''"></div>
          </li>
          <li class="_width _heigth"
              @click="change(1)">圈子<span v-if="user_data.circleCount">({{user_data.circleCount}})</span>
            <div :class="menubox== 1 ? 'show_top':''"></div>
          </li>

          <li class="_width"
              @click="change(2)">影展<span v-if="user_data.photoshowCount">({{user_data.photoshowCount}})</span>
            <div :class="menubox== 2 ? 'show_top':''"></div>
          </li>

          <li class="_width _heigth"
              @click="change(3)">关注<span v-if="user_data.followCount">({{user_data.followCount}})</span>
            <div :class="menubox== 3 ? 'show_top':''"></div>
          </li>
          <li class="_width _heigth"
              @click="change(4)">粉丝<span v-if="user_data.fansCount">({{user_data.fansCount}})</span>
            <div :class="menubox== 4 ? 'show_top':''"></div>
          </li>
        </ul>
      </div>

    </div>

    <!-- 内容 -->
    <div class="content _width">
      <div class="wrap">
        <div v-show="menubox== 0">
          <Uworks @update_data="father_son_update"></Uworks>
        </div>
        <div v-show="menubox== 1">
          <Ucircle @update_data="father_son_update"></Ucircle>
        </div>
        <div v-show="menubox== 2">
          <UPhotoShow @update_data="father_son_update"
                      ref='UPhotoShow'>
          </UPhotoShow>
        </div>
        <div v-show="menubox== 3">
          <Ufollows @update_data="father_son_update"></Ufollows>
        </div>
        <div v-show="menubox== 4">
          <Ufans @update_data="father_son_update"></Ufans>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import communityHeader from '@/components/community/common/communityHeader.vue'
import Ucircle from '@/components/ucenter/Ucircle'
import Ufans from '@/components/ucenter/Ufans'
import Ufollows from '@/components/ucenter/Ufollows'
import UPhotoShow from '@/components/ucenter/UPhotoShow'
import Uworks from '@/components/ucenter/Uworks'
import Loading from '@/components/loading/loading.vue'
import { Info } from '@/utils/api/login.js'
import { update_bag_data } from '@/utils/api/ucenter.js'//封面接口


import {
  me_user_data
} from '@/utils/api/ucenter.js' //用户信息

export default {
  inject: ['reload'],
  name: "ucenter",
  data () {
    return {
      loading_bool: true, //加载loading
      user_data: [], //header 用户数据
      menubox: '', //组件选择高亮以及状态
      panelShow: false,
      user_data_bag: '',//bag
      error_bag: require("@/assets/image/common/ta.png"),
      imageUrl: '',//封面
      defaultImg: 'this.src="' + require('@/assets/image/common/loading.gif') + '"',//未加载
      error_login: require('@/assets/image/common/loading.gif'),
      isLogin_user: {},

    }
  },


  watch: {
    '$route' (to, from) { //监听路由是否变化
      if (to.query.type != from.query.type) {
        this.type = to.query.type;
        // this.init();//重新加载数据
        this.reload()
        // console.log('强制刷新');
      }
    }
  },

  created () {

    this.is_login();//是否登陆
    this.router_url = this.$route.fullPath;//当前地址url
    let userId = this.$route.params && this.$route.params.id
    this.userId = userId;
    let params = {
      userId: this.userId,
    }
    let type = this.$route.query.type;
    if (type) {
      if (type == 0) {
        this.menubox = 0
      } else if (type == 1) {
        this.menubox = 1;
      } else if (type == 2) {
        this.menubox = 2;
      } else if (type == 3) {
        this.menubox = 3;
      } else if (type == 4) {
        this.menubox = 4;
      }
    }
    this.header_ucenter_user(); //用户基本细信息
  },
  methods: {
    // 上传用户封面
    // update_img () {
    // this.$router.push({
    //   path: '/Puploadfile',
    //   query: {
    //     photoshowId: this.user_data.userId,
    //   }
    // })
    // },

    // 成功后的回调
    handleAvatarSuccess (res, file) {
      console.log(res);
      console.log(file);

      if (res.code == 200) {
        this.$message({
          message: '更换成功',
          type: 'success'
        });
        this.user_data_bag = res.backgroundPUrl;
        this.header_ucenter_user()
      } else {
        this.$message.error(res.info);

      }
      console.log(this.user_data_bag);
    },


    beforeAvatarUpload (file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 5;
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
      }
      return isLt2M;
    },



    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
        if (this.isLogin == true) {
          this.isLogin_user = data.user
        } else {
          sessionStorage.setItem('router_url', this.router_url)//活动详情
          this.$router.push(
            {
              path: '/login/?state=' + 1,
            }
          )
        }
      })
    },


    // 切换导航
    change (index) {
      this.menubox = index
      if (index == 0) {
        this.$router.push({
          path: '/Pcenter?type=0'
        })
      } else if (index == 1) {
        this.$router.push({
          path: '/Pcenter?type=1'
        })
      } else if (index == 2) {
        this.$router.push({
          path: '/Pcenter?type=2'
        })
      } else if (index == 3) {
        this.$router.push({
          path: '/Pcenter?type=3'
        })
      } else if (index == 4) {
        this.$router.push({
          path: '/Pcenter?type=4'
        })
      }
    },

    // 用户自己主页信息
    header_ucenter_user () {
      this.loading_bool = true;
      me_user_data().then((res) => {
        let data = res.data;
        this.user_data = data.data
        this.user_data_bag = data.data.backgroundpUrl
        document.title = '中经视觉-' + this.user_data.realname

        this.loading_bool = false;
      })
    },


    // 当前不是影展页面的的时候 跳转至影展
    go_commp () {
      this.$router.push({
        path: '/Pcenter?type=2'
      })
    },
    // 点击  向子组件传递参数   控制子组件的创建弹窗显示
    myclick (id) {
      this.$router.push({ path: "/Puploadfile?photoshowId" });
    },
    // 父组件更新
    father_son_update () {
      let params = {
        userId: this.userId,
      }
      // console.log('父组件更新')
      this.header_ucenter_user(params);
    },
  },

  components: {
    communityHeader,
    Ucircle,
    Ufans,
    Ufollows,
    UPhotoShow,
    Uworks,
    Loading
  }
}
</script>
<style scoped>
@import "../../assets/css/Ucenter/index.css";
.user_header_menu {
  z-index: 33;
}
.user_bag {
  position: absolute;
  top: 0px;
  z-index: 30;
}
.up_bag {
  z-index: 33;
}
.up_bag >>> .el-upload:focus {
  border-color: #d5182e;
  color: #d5182e;
}

.error_img {
  position: absolute;
}

.pd_15 {
  padding: 0 30px 30px;
}
.up_bag {
  height: 0.88rem;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
}
.up_bag .wrap {
  display: -webkit-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.up_bag button {
  display: inline-block;
  height: 0.38rem;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 0.03rem;
  border: none;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  cursor: pointer;
  font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei", "HanHei SC",
    "Helvetica Neue", "Open Sans", Arial, "Hiragino Sans GB",
    "\5FAE\8F6F\96C5\9ED1", STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif;
  font-size: 0.14rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.38rem;
  letter-spacing: 0.02rem;
  padding: 0 0.19rem;
  color: #ffffff;
  transition: all 0.3s;
  cursor: pointer;
}
.up_bag button:hover {
  background-color: rgba(0, 0, 0, 0.35);
}
</style>



// WEBPACK FOOTER //
// src/views/community/Pcenter.vue